import { Text } from '@yes.technology/react-toolkit'
import { useRef } from 'react'
import { ItemButton, ItemContainer } from './TabItem.styles'
import {
  TextClassesEnum,
  TextClassesEnumFocused,
  textColorMap
} from './Tabs.enum'
import { TabItemProps } from './Tabs.types'

export default function TabItem({
  tab,
  selectedTabUuid,
  highlightColor,
  heightClass,
  textColor,
  disabled,
  focusable = true,
  onItemSelected
}: TabItemProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isSelected = !!selectedTabUuid ? tab?.uuid === selectedTabUuid : false
  const textVariant = isSelected
    ? TextClassesEnumFocused[heightClass]
    : TextClassesEnum[heightClass]
  const textColorClass =
    isSelected && !disabled && highlightColor
      ? highlightColor
      : textColorMap[textColor]

  return (
    <ItemContainer heightClass={heightClass} ref={containerRef}>
      <ItemButton
        ref={buttonRef}
        role='tab'
        type='button'
        aria-selected={isSelected}
        disabled={disabled}
        focusable={focusable}
        tabIndex={focusable ? 0 : -1}
        onClick={() => {
          buttonRef?.current?.blur()
          onItemSelected(tab)
        }}
      >
        <Text variant={textVariant} style={{ color: textColorClass }}>
          {tab.des}
        </Text>
      </ItemButton>
    </ItemContainer>
  )
}
